// extracted by mini-css-extract-plugin
export default {"verifiedIcon":"styles_verifiedIcon__tXTZ1","warningIcon":"styles_warningIcon__Mx45U"};